import React, { JSX } from 'react'
import './index.scss'
import clsx from 'clsx'
import { v4 as uuidv4 } from 'uuid'
import MlcTooltip from '@Components/Tooltips/MlcTooltip'
import { PlacesType } from 'react-tooltip'

interface CustomToolTipProps {
    title?: string
    info: string | JSX.Element
    type?: '?' | 'i'
    inverse?: boolean
    place?: PlacesType
}

const CustomToolTip = ({ title, info, type, inverse, place }: CustomToolTipProps) => {
    const toolTipId = uuidv4()

    return (
        <>
            <span className={clsx('custom-tool-tip', inverse && 'inverse')}>
                {type ? (
                    <span className="info-label">
                        <span data-tooltip-id={toolTipId}>{type}</span>
                    </span>
                ) : (
                    <p data-tooltip-id={toolTipId}>{title}</p>
                )}
            </span>
            <MlcTooltip id={toolTipId} variant="info" place={place ?? 'bottom'} className="custom-tool-tip-content">
                <span>{info}</span>
            </MlcTooltip>
        </>
    )
}

export default CustomToolTip
